import { useNavigate, useSearchParams } from "react-router-dom";

import DeleteTimeOffRequestConfirmation from "../request-new-edit-remove/DeleteTimeOffRequestConfirmation";
import EditTimeOffRequestForm from "../request-new-edit-remove/EditTimeOffRequestForm";
import Modal from "shared/components/feedback/modals/MasterModal";
import MyRequestTimeOffTable from "features/timesheet/time-off/time-off-list/MyRequestTimeOffTable";
import NewTimeOffRequestForm from "../request-new-edit-remove/NewTimeOffRequestForm";
import React from "react";
import Text from "shared/components/data-display/text/Text";
import VStack from "shared/components/layout/stack/VStack";

const FormPresenter = () => {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const action = searchParams.get("action");
    const id = searchParams.get("id");

    const onClose = () => {
        navigate(".", { replace: true });
    };

    if (action === "add") {
        return (
            <Modal
                title="Time Off Request"
                stickyAction={true}
                onRequestClose={onClose}
            >
                <NewTimeOffRequestForm key="new" onClose={onClose} />
            </Modal>
        );
    }

    const parsedId = Number.parseInt(id);

    if (action === "edit" && !Number.isNaN(parsedId)) {
        return (
            <Modal
                title="Time Off Request"
                stickyAction={true}
                onRequestClose={onClose}
            >
                <EditTimeOffRequestForm
                    timeOffIdToEdit={parsedId}
                    key={parsedId}
                    onClose={onClose}
                />
            </Modal>
        );
    }

    if (action === "delete" && !Number.isNaN(parsedId)) {
        return (
            <Modal title="Time Off Request" onRequestClose={onClose}>
                <DeleteTimeOffRequestConfirmation
                    timeOffRequestIdToDelete={parsedId}
                    key={parsedId}
                    onClose={onClose}
                />
            </Modal>
        );
    }

    return <></>;
};

const MyRequestsTimeOff = () => {
    const title = "Requests";

    return (
        <VStack>
                <Text variant="Headline_4" color={"Gray_1"}>
                    {title}
                </Text>
                <VStack>
                    <FormPresenter />
                    <MyRequestTimeOffTable />
                </VStack>
        </VStack>
    );
};

export default MyRequestsTimeOff;
